import script from "./IpTableView.vue?vue&type=script&setup=true&lang=js"
export * from "./IpTableView.vue?vue&type=script&setup=true&lang=js"

import "./IpTableView.vue?vue&type=style&index=0&id=6777145a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6777145a"]])

export default __exports__